import { createSlice } from '@reduxjs/toolkit';
import { IPromotionsDetailState } from '../types';
import { getPromotionsDetail } from '../../service/api';

const initialState: IPromotionsDetailState = {
  page: null,
  pending: false,
  error: null,
};

export const promotionsDetailSlice = createSlice({
  name: 'promotionsDetailSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPromotionsDetail.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(getPromotionsDetail.fulfilled, (state, action) => {
        state.page = action.payload;
        state.pending = false;
      })
      .addCase(getPromotionsDetail.rejected, (state, action) => {
        if (action.error.message !== undefined) {
          state.error = action.error.message;
        }
        state.pending = true;
      });
  },
});

export default promotionsDetailSlice.reducer;
